import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ToastController, AlertController, App } from 'ionic-angular';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';
import { QnalistPage } from '../qnalist/qnalist';

// declare var google;

/**
 * Generated class for the QnaformPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
	selector: 'page-qnaform',
	templateUrl: 'qnaform.html',
})
export class QnaformPage {

	wallet_address: string;

    imageURI: any;
    imageFileName: any;
    
    loginId: string = '';
    api_key: string = '';
    version: string = '';
    title: string = '';
    content: string = '';

    photos : any = [];
    base64Image : string;
    isImgmax : boolean = true;

    texts : any = [];
    language: string;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        private camera: Camera,
        private http: HttpService,
        public loadingCtrl: LoadingController,
        public toastCtrl: ToastController,
        public alertCtrl: AlertController,
		public app: App
    ) {

    }

    ionViewWillEnter() {
        //// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
        if(!this.api_key) {
            this.app.getRootNav().setRoot(LoginPage);
        }

        //// 페이지 이름
        localStorage.setItem("pageName", "qnaform");
        this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");

        this._get_texts();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).qnaform;
	}

    ngOnInit() {
        this.photos = [];
    }

    _getImage() {
        // if(this.photos.length <= 3) {
            const options: CameraOptions = {
                quality: 30,
                //촬영-CAMERA, 갤러리-PHOTOLIBRARY
                sourceType:this.camera.PictureSourceType.PHOTOLIBRARY,
                //URL을 어떤 형식으로 받을지..
                destinationType: this.camera.DestinationType.DATA_URL,
                encodingType: this.camera.EncodingType.JPEG,
                mediaType: this.camera.MediaType.PICTURE,
            }
        
            this.camera.getPicture(options).then((imageData) => {
                
                    let loader = this.loadingCtrl.create({
                        content: "loading..."
                    });
                    loader.present();
                    this.base64Image = "data:image/jpeg;base64," + imageData;
                    this.photos.push(this.base64Image);
                    this.photos.reverse();
                    loader.dismiss();
                    if(this.photos.length >= 3) {
                        this.isImgmax = false;
                    }
                    console.log(this.photos.length);
            }, (err) => {
                console.log(err);
            });

    }

    _takePhoto() {
        const options : CameraOptions = {
          quality: 30, // picture quality
          destinationType: this.camera.DestinationType.DATA_URL,
          encodingType: this.camera.EncodingType.JPEG,
          mediaType: this.camera.MediaType.PICTURE
        }
        this.camera.getPicture(options) .then((imageData) => {
            let loader = this.loadingCtrl.create({
                content: "loading..."
            });
            loader.present();

            this.base64Image = "data:image/jpeg;base64," + imageData;
            this.photos.push(this.base64Image);
            this.photos.reverse();
            loader.dismiss();
            if(this.photos.length >= 3) {
                this.isImgmax = false;
            }
          }, (err) => {
            console.log(err);
          });
    }

    _regist() {

        let body= JSON.stringify({
            api: this.api_key,
            language: this.language,
            version: this.version,
            title :this.title,
            content : this.content,
            photos: this.photos
        });

        this.http.post('info/qa/index/save', body).then((res: any) => {
            if (res.result == 'OK'){
                let alert = this.alertCtrl.create({
                    message: this.texts.alertM,
                    buttons: [
                      {
                        text: 'OK',
                        handler: () => {
							this.navCtrl.popToRoot(this.navCtrl.parent.select());
							this.navCtrl.push(QnalistPage);  
                        }
                      }
                    ]
                  });
                  alert.present();
            } else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
            }

        },(err)=>{
            let alert = this.alertCtrl.create({
                message: this.texts.alertM_err,
                buttons: ['OK']
            });
            alert.present();
            
        });
    }

    _deletePhoto(index){
        this.photos.splice(index, 1);
        this.isImgmax = true;
    }
}



// WEBPACK FOOTER //
// ./src/pages/qnaform/qnaform.ts